import React from 'react'
import { FaSquare, FaRegSquare, FaCheckSquare } from 'react-icons/fa'

// FaCheckSquare - All Selected = true
// FaRegSquare - None Selected = false
// FaSquare - Not All Selected = null

function CustomTriStateCheckbox({ value, onClick }) {
  switch (value) {
    case true:
      return <FaCheckSquare size={18} onClick={() => onClick(true)} />
    case false:
      return <FaRegSquare size={18} onClick={() => onClick(false)} />
    case null:
      return <FaSquare size={18} onClick={() => onClick(null)} />
    default:
      throw new Error(`Tri-State Checkbox Invalid Value: ${value}`)
  }
}

export default CustomTriStateCheckbox
